import React from 'react';
import ENUMS from '../../../enums';
import { enumHelper } from '../../../utils';
import { connect } from 'react-redux';
import Pagination2 from '../../../components/Pagination2';
import * as reservationsActions from '../../../redux/reservations/actions';

class UserReservationsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      itemsPerPage: 10,
      userReservationOpen: false,
      selectedUserReservationId: null,
      deleteUserReservationOpen: false,
      userReservationDetailsOpen: false,
      status: '',
      isActive: false,
    };
  }

  componentDidMount() {
    this.props.fetchAllUserReservations(
      `pageNumber=${this.state.currentPage}&pageSize=${this.state.itemsPerPage}`,
    );
  }

  closeDeleteUserReservation = () => {
    this.props
      .fetchAllUserReservations(`pageNumber=${this.state.currentPage}&pageSize=${this.state.itemsPerPage}`)
      .then(() => {
        this.setState(() => ({
          deleteUserReservationOpen: false,
        }));
      });
  };

  closeUserReservationDetails = () => {
    this.props
      .fetchAllUserReservations(`pageNumber=${this.state.currentPage}&pageSize=${this.state.itemsPerPage}`)
      .then(() => {
        this.setState(() => ({
          userReservationDetailsOpen: false,
        }));
      });
  };

  displayDeleteUserReservation = id => {
    let { userReservationsList = [] } = this.props;
    let selectedUserReservationId = userReservationsList.filter(
      userReservation => userReservation.id == id,
    )[0].id;
    this.setState({ deleteUserReservationOpen: true, selectedUserReservationId });
  };

  displayUserReservationDetailsModal = id => {
    let { userReservationsList = [] } = this.props;
    let selectedUserReservationId = userReservationsList.filter(
      userReservation => userReservation.id == id,
    )[0].id;
    this.setState({ userReservationDetailsOpen: true, selectedUserReservationId });
  };

  renderStatusColors = status => {
    switch (status) {
      case 'WAITING':
        return 'text-warning';
      case 'APPROVED':
        return 'text-success';
      case 'AUTO_APPROVED':
        return 'text-primary';
      case 'REJECTED':
        return 'text-danger';
      case 'STARTED':
        return 'text-info';
      case 'CLIENT_DO_NOT_CAME':
        return 'text-muted';
      case 'FINISHED':
        return 'text-secondary';
      default:
        return 'text-dark';
    }
  };

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      console.log('pageNumber is: ', pageNumber);
      console.log('pageSize is: ', pageSize);
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  onPageChanged = data => {
    const { currentPage, totalPages, pageLimit } = data;

    console.log('pagination data: ', data);

    this.setState({ currentPage: currentPage }, () => {
      const query = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.fetchAllUserReservations(query);
    });
  };

  render() {
    let { userReservationsList = {}, userReservations } = this.props;
    let { itemsPerPage, currentPage } = this.state;
    let { totalRecords } = userReservations;

    return (
      <div className="table-responsive">
        <table className="table table-hover table-light table-striped">
          <thead>
          <tr>
            <th className="text-center">{locales('tables.row')}</th>
            <th className="text-center">{locales('tables.requestor')}</th>
            <th className="text-center">{locales('fields.cafe.name')}</th>
            <th className="text-center">{locales('fields.createdAt')}</th>
            <th className="text-center">{locales('tables.reserveStartingTime')}</th>
            <th className="text-center">{locales('tables.reserveEndingTime')}</th>
            <th className="text-center ">{locales('messages.tables')}</th>
            <th className="text-center">{locales('tables.reservationType')}</th>
            <th className="text-center">{locales('fields.trackingNumber')}</th>
            <th className="text-center">{locales('tables.peopleCount')}</th>
            <th className="text-center">{locales('tables.mealPortions')}</th>
            <th className="text-center">{locales('tables.status')}</th>
          </tr>
          </thead>
          <tbody>
          {userReservationsList.length ? (
            userReservationsList.map((cafeReservation, index) => (
              <tr className={`${cafeReservation.isSuspended ? 'danger-row' : ''}`} key={cafeReservation.id}>
                <td className="text-center">{(currentPage - 1) * itemsPerPage + index + 1}</td>
                <td className="text-center">{cafeReservation.createdFullName}</td>
                <td className="text-center">{cafeReservation.cafeName}</td>
                <td className="text-center">{cafeReservation.date}</td>
                <td className="text-center">{cafeReservation.startAt}</td>
                <td className="text-center">{cafeReservation.endAt}</td>
                <td className="text-center">
                  {cafeReservation.reservedTables &&
                  cafeReservation.reservedTables.length &&
                  cafeReservation.reservedTables.map(
                    (ele, index, self) => ` ${ele.num} ${index < self.length - 1 ? '،' : ''}`,
                  )}
                </td>
                <td className="text-center">
                  {enumHelper.convertEnumValueToTitle(
                    ENUMS.RESERVATION_TYPES.list,
                    cafeReservation.reserveType,
                  )}
                </td>
                <td className="text-center direction-ltr">{cafeReservation.trackingNumber}</td>
                <td className="text-center">{cafeReservation.persons}</td>
                <td className="text-center">
                  {enumHelper.convertEnumValueToTitle(ENUMS.MEAL_PORTIONS.list, cafeReservation.meal)}
                </td>
                <td className={`text-center ${this.renderStatusColors(cafeReservation.status)}`}>
                  {enumHelper.convertEnumValueToTitle(ENUMS.CAFE_RESERVATION.list, cafeReservation.status)}
                </td>
              </tr>
            ))
          ) : (
            <tr className="col-12 text-center">
              <td className="alert alert-info" colSpan={12}>
                {locales('alerts.noRecord')}
              </td>
            </tr>
          )}
          </tbody>
        </table>
        <footer className="col-12 d-flex justify-content-center py-2">
          <div className="pagination-container">
            <Pagination2
              totalRecords={totalRecords || 0}
              pageLimit={itemsPerPage}
              pageNeighbours={2}
              onPageChanged={this.onPageChanged}
              currentPage={this.state.currentPage}
            />
          </div>
        </footer>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    userReservationsLoading: state.reservationsReducer.userReservationsLoading,
    userReservationsFailed: state.reservationsReducer.userReservationsFailed,
    userReservationsError: state.reservationsReducer.userReservationError,
    userReservationsMessage: state.reservationsReducer.userReservationsMessage,
    userReservationsList: state.reservationsReducer.userReservationsList,
    userReservations: state.reservationsReducer.userReservations,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    fetchAllUserReservations: query =>
      dispatch(reservationsActions.fetchAllUserReservations(props.userId, query)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UserReservationsTable);
